import { Component, OnInit, ViewChild } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import { ActivatedRoute } from '@angular/router';

import { PracticasComponent } from "./practicas/practicas.component";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { ForAllService } from 'app/main/wizard-cgo/services/forall.service';
import { ForAllService as ForAllSrv } from './for-all.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import { PreguntasService } from "app/main/pagina/productos/certificar/tipo_2/preguntas/preguntas.service";

@Component({
  selector: 'app-for-all',
  templateUrl: './for-all.component.html',
  styleUrls: ['./for-all.component.scss']
})
export class ForAllComponent implements OnInit {

  // @ViewChild(PracticasComponent, {static: false}) nativo: PracticasComponent;
  actualizaTraducciones: Subject<any> = new Subject<any>();
  statusPaso: Subject<any> = new Subject<any>();


  numeroPracticas: number;
  instituto: string;
  pasoCompleto = false;
  changeInfoFin:boolean=false;
  productoCertificar: any;
  token: any;
  practicasCompletas = true;
  actualizaJsonTrad: Subject<any> = new Subject<any>();
  traduccionesCompletas: boolean;
  traduccionesTab = true;
  idiomasGuardados: Subject<any> = new Subject<any>();
  seccionesGuardadas: Subject<any> = new Subject<any>();
  numeroGrupos: number;
  numeroPreguntas: number = 0;

  validationUser: boolean;
  desbloqueoEstatus: boolean;
  validationSurvey: boolean;

  catalogoIdiomasSurvey: any;
  seccionesDemo: any;
  idiomaNative = "es";
  nameUserAdmin:any="";

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private forallService: ForAllService,
    private forAllSrv: ForAllSrv,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
    private preguntasService: PreguntasService,
    private activatedRoute: ActivatedRoute,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_cerv3.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('userBypass')){
      let userData = JSON.parse(localStorage.getItem('userBypass'));
      if(userData.level==3 || userData.level==2){
        this.validationUser=true;
        this.nameUserAdmin=userData.user;
      }
      else{
        this.validationUser=false;
        this.nameUserAdmin="";
      }
    }
  }

  ngOnInit() {
    //this.obtieneCertificarActual();
    this.getInstituto();
    this.getCatIdiomasSurvey(); // Nuevo función certv3
    this.getCertificar(); // Nuevo función certv3
    //this.actualizaListasPreguntas(); // Nuevo función certv3
  }
  getCatIdiomasSurvey(){// Nuevo servicio certv3
    this.forAllSrv.getCatIdiomasSurvey().subscribe((respuesta:any) => {
      console.log("getCatIdiomasSurvey",respuesta);
      this.catalogoIdiomasSurvey = respuesta.languages;
    });
  }
  getCertificar(){// Nuevo servicio certv3
    this.forAllSrv.getProdCertAct().subscribe((data:any) => {
      let prodsCertificar:any[] = data.productosCertificar;
      let indiceProducto = prodsCertificar.findIndex(item => item.fechaCertificar == parseInt(localStorage.getItem('fechaProducto')) && item.idCertificar == localStorage.getItem('productoID'));
      if(indiceProducto != -1){
        this.productoCertificar = prodsCertificar[indiceProducto];
        //this.getSeccionesCuestionario();
        this.obtieneIdiomasGuardados();
        let datos: any = {
          productoId: this.productoCertificar.idCertificar,
          forall: 1 //agrega el parametro de acuerdo al producto visualizado
        };
        this.forAllSrv.getStatusProd(datos).subscribe( (data: any) => {
          if(data.estatus === 3){
            this.pasoCompleto = true;
          }
          this.statusPaso.next(this.pasoCompleto);
          this.changeInfoFin=true;
        });
        this.getStatusModal();
      }
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  obtieneIdiomasGuardados(){// Nuevo servicio certv3
    let datos: any = {productoId:this.productoCertificar.idCertificar};
    this.forAllSrv.getIdiomasProd(datos).subscribe( (data: any) => {
      console.log("getIdiomasProd ",data);
      this.idiomas = data.idiomasMostrar;
      let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
      this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
      let idiomasAdicionales: any[] = [];
      this.idiomas.forEach(idioma => {
        if(idioma.tipoIdioma == '0'){
          idiomasAdicionales.push(idioma);
        }
      });
      if(idiomasAdicionales.length > 0){
        this.showHtml = true;
        this.traduccionesTab = true;
      }
      else this.traduccionesTab = false;
    });
  }


  actualiza(event:any){
    this.actualizaTraducciones.next(event);
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; this.practicasCompletas = false; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; this.practicasCompletas = false; break;
      case '15': case 'ES': this.instituto = 'ES'; break;
    }
  }

  numPracticas(numero:number){
    this.numeroPracticas = numero;
  }

  traducciones: any;
  idiomas: any;
  showHtml:boolean=false;
  getIdiomasEncuesta(){
    let data = {
      productoId: this.productoCertificar.idCertificar
    };
    this.traducciones = [];
    this.forallService.getIdiomasEncuesta(data).subscribe((respuesta:any) => {
      console.log("getIdiomasEncuesta:",respuesta);
      this.idiomas = respuesta.idiomasMostrar;
      console.log(this.idiomas.length);
      if(this.idiomas.length>0){
        this.showHtml=true;
      }

    }, error => {
      console.log("error", error);
    })
  }

  getStatusEncuesta(token:any){
    if(token){
      this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
        // console.log(data);
        if(data.result.id_status == 1){
          this.validationSurvey = true;
        }
        else{
          this.validationSurvey = false;
        }
      });
    }
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idCertificar).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo){
        this.desbloqueoEstatus = true;
      }
      else{
        this.desbloqueoEstatus = false;
      }
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      forall: 1
    };
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
        this.modalInformativo('FORALL');
      }
    });
  }
  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      forall: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }
  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

  completarPaso(){
    if(this.pasoCompleto){
      //this.aletaRestric('FORALL.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ['background-red']
      });
    }
    else{
      this.modalGuardado();
      setTimeout(() => {
        this.validacionPracticasTemplate();
      }, 1000);
      // this.validacionPracticas();
      // this.aletaRestric('FORALL.COMPLETAR',true);
    }
  }

  validacionPracticasTemplate(){
    let numeroPracticas: number = 0;
    this.seccionesDemo.forEach(seccion => {
      if(seccion.questions.length > 0){
        let practicasCompletas = true;
        let BreakException = {};
        try {
          seccion.questions.forEach((pregunta,i) => {
            let indiceNativo = pregunta.questionLanguage.findIndex(item => item.lang == this.idiomaNative);
            if(i % 2 == 0){
              if(pregunta.questionLanguage[indiceNativo].description4all == ''){
                practicasCompletas = false;
                throw BreakException;
              }
            }
            if(pregunta.questionLanguage[indiceNativo].question == '' || pregunta.questionLanguage[indiceNativo].practice4all == ''){
                practicasCompletas = false;
                throw BreakException;
            }
            else numeroPracticas++;
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
        console.log(practicasCompletas);

        if(practicasCompletas){
          // if((numeroPracticas / 2) >= seccion.minQuestions){
          if((numeroPracticas / 2) == seccion.maxQuestions){
            console.log("traducciones:",this.traduccionesCompletas);
            if (!this.traduccionesTab) {
              this.traduccionesCompletas=true;
            }

            if(this.traduccionesCompletas){
              this.aletaRestric('FORALL.COMPLETAR',true);
            }
            else{
              this.aletaRestric('FORALL.FALTANTES_TRADUCCIONES',null,'warning');
            }
          }
          else{
            console.log("caso 1");
            this.aletaRestric('FORALL.NADA',null,'warning');
          }
        }
        else{
          console.log("caso 2");
          this.aletaRestric('FORALL.NADA',null,'warning');
        }
      }
      else{
        console.log("caso 3");
        this.aletaRestric('FORALL.NADA',null,'warning');
      }
    });


  }

  modalGuardado(){
    let mensaje: string;
    this.translateSrv.get('CERTIFICAR.FORALL.REVISANDO_PRACTICAS').subscribe((res: string) => { mensaje = res; });
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          let datos: any = {
            accionText:'completePas4all',
            productoId:this.productoCertificar.idCertificar,
            forall: 3, //agrega el parametro de acuerdo al producto visualizado
            userAdministrator:this.nameUserAdmin,
            actualizar: 1,
          };
          this.forAllSrv.guardaStatusProd(datos).subscribe( (data: any) => {
            if(data.message == '212'){
              //this.aletaRestric('FORALL.'+data.message,null,'success');
              this.openSnackBar(this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL' + '.' + data.message),"OK");
              this.pasoCompleto = true;
              this.statusPaso.next(this.pasoCompleto);
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }
  desbloquear4all(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'DescompletePas4all',
            productoId:this.productoCertificar.idCertificar,
            forall: 2,
            userAdministrator:this.nameUserAdmin,
            actualizar: 1,
          }
          console.log("Descompletar paso 4all");
          this.forallService.DesbloquearPasoForAll(datos).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '212'){
               this.pasoCompleto = false;
               this.openSnackBar(succes,"OK");
               this.enviaOrdenWizard();
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,

               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,

        confirmButtonText: cerrar,
        })
      }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }


  actualizaCuestionarioTrad(event:any){
    this.actualizaJsonTrad.next(event);
  }

  enviaIdiomasGuardados(event:any){
    this.idiomasGuardados.next(event);
  }

  enviaSeccionesGuardadas(event:any){
    this.seccionesGuardadas.next(event);
    this.numeroGrupos = event.seccionesDemo.length;
    this.seccionesDemo = event.seccionesDemo;
    this.idiomaNative = event.idiomaNative;
    if(this.numeroGrupos > 0){
      event.seccionesDemo.forEach(grupo => {
        this.numeroPreguntas += grupo.questions.length;
      });
    }
    console.log("numeroGrupos:",this.numeroGrupos);
    console.log("numeroPreguntas:",this.numeroPreguntas);

  }



}
